var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/img/wecom-temp-7a5e699c763eca5bceda89b3116206e3.png"),"alt":"","srcset":""}})])
}]

export { render, staticRenderFns }